import classnames from "classnames";
import { ReactNode } from "react";
import { ErrorBoundary } from "components/ErrorBoundary";
import { getErrorComponents } from "services/util";
import "./PageWithHeaderFooter.css";

type PageWithHeaderFooterProps = {
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  header?: ReactNode;
  pathname?: string;
};

export default function PageWithHeaderFooter(props: PageWithHeaderFooterProps) {
  return (
    <div className={classnames("PageWithHeaderFooter", props.className)}>
      <ErrorBoundary fallback={getErrorComponents("Something went wrong.")}>
        {props.header}
      </ErrorBoundary>
      <ErrorBoundary pathname={props.pathname}>{props.children}</ErrorBoundary>
      <ErrorBoundary fallback={getErrorComponents("Something went wrong.")}>
        {props.footer}
      </ErrorBoundary>
    </div>
  );
}
